import { Component, forwardRef } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { InputBase } from "../input-base";

@Component({
    selector: "hcc-checkbox",
    templateUrl: "./checkbox.component.html",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true
        }
    ],
    standalone: false
})
export class CheckboxComponent extends InputBase<boolean> {
  constructor() {
    super();
  }
}
